module.exports = __webpack_public_path__ + "static/media/logo-ragione-emozione@2x.81a49524.png";